/* unplugin-vue-components disabled */import { render } from "./PreventionGuide.vue?vue&type=template&id=56a8764d&scoped=true"
import script from "./PreventionGuide.vue?vue&type=script&lang=js"
export * from "./PreventionGuide.vue?vue&type=script&lang=js"

import "./PreventionGuide.vue?vue&type=style&index=0&id=56a8764d&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a8764d"]])

export default __exports__